import { Periods } from '@shared/utils/History/TFInfo';
// Period of data.
export const Period = {
    // Tick Period.
    Tick: Periods.TIC,
    // 1 Minute Period.
    Min: Periods.MIN,
    // 5 Minute Period.
    Min5: Periods.MIN5,
    // 15 Minute Period.
    Min15: Periods.MIN15,
    // 30 Minute Period.
    Min30: Periods.MIN30,
    // 1 Hour Period.
    Hour: Periods.HOUR,
    // 4 Hour Period.
    Hour4: Periods.HOUR4,
    // 1 Day Period.
    Day: Periods.DAY,
    // 1 Week Pertiod.
    Week: Periods.WEEK,
    // 1 Monthl Period.
    Month: Periods.MONTH,
    // 1 Year Period.
    Year: Periods.YEAR,
    // 1 Second Period.
    Second: Periods.SECOND,
    // Price range period
    Range: Periods.RANGE
};
// Provide access to different history types.
export var IndicatorHistoryType;
(function (IndicatorHistoryType) {
    // Simple bars objects represent the Time, Tick, Price Range bars of data.
    IndicatorHistoryType[IndicatorHistoryType["Simple"] = 0] = "Simple";
    // Represent access to Renko bars objects.
    IndicatorHistoryType[IndicatorHistoryType["Renko"] = 6] = "Renko";
    // Represent access to Kagi bars objects.
    IndicatorHistoryType[IndicatorHistoryType["Kagi"] = 3] = "Kagi";
    // Represent access to Line Break bars objects.
    IndicatorHistoryType[IndicatorHistoryType["LineBreak"] = 4] = "LineBreak";
    // Represent access to PnF bars objects.
    IndicatorHistoryType[IndicatorHistoryType["PnF"] = 5] = "PnF";
    // Represent access to HeikinAshi bars objects.
    IndicatorHistoryType[IndicatorHistoryType["HeikinAshi"] = 2] = "HeikinAshi";
})(IndicatorHistoryType || (IndicatorHistoryType = {}));
// Style of bars aggregations.
// ByWicks and Advanced use only for Renko chart,
// ByHighLow use for Renko and PnF charts.
export var IndicatorBarsAggregations;
(function (IndicatorBarsAggregations) {
    // This value mean no, or classic aggregations type.
    IndicatorBarsAggregations[IndicatorBarsAggregations["None"] = 0] = "None";
    // This value will result in creating a renko data with wicks,
    // which will provide more information to the trader than the standard renko bricks do.
    IndicatorBarsAggregations[IndicatorBarsAggregations["ByWicks"] = 1] = "ByWicks";
    // Use high/low method, for Renko and PnF.
    IndicatorBarsAggregations[IndicatorBarsAggregations["ByHighLow"] = 2] = "ByHighLow";
    // Use Renko Advanced mode
    IndicatorBarsAggregations[IndicatorBarsAggregations["Advanced"] = 4] = "Advanced";
    // Use Renko Advanced high/low mode
    IndicatorBarsAggregations[IndicatorBarsAggregations["AdvancedHighLow"] = 8] = "AdvancedHighLow";
})(IndicatorBarsAggregations || (IndicatorBarsAggregations = {}));
// Supported history data types.
export var IndicatorDataType;
(function (IndicatorDataType) {
    // Quote history with Bid as source.
    IndicatorDataType[IndicatorDataType["Bid"] = 1] = "Bid";
    // Quote history with Ask as source.
    IndicatorDataType[IndicatorDataType["Ask"] = 1000] = "Ask";
    // History is building by trades.
    IndicatorDataType[IndicatorDataType["Trade"] = 4] = "Trade";
})(IndicatorDataType || (IndicatorDataType = {}));
